var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('a',{staticClass:"logo",attrs:{"href":"/"}},[_c('img',{attrs:{"alt":"Budsies logo","src":require("@/assets/logo.png")}})])])}]

export { render, staticRenderFns }